export const getCompanionPortalRoute = ({
  path,
  isCompanionHost,
}: {
  path: string;
  isCompanionHost: boolean;
}) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  if (isCompanionHost) return normalizedPath;

  return normalizedPath === "/"
    ? "/companion"
    : `/companion${normalizedPath}`;
};
